"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getLaquesisFFCookie = getLaquesisFFCookie;
var _getFeatureFlagCookieName = _interopRequireDefault(require("./getFeatureFlagCookieName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** Get the laquesisff cookie from a string, usually document.cookie
 *
 * @deprecated Laquesis does not check for user's consent when reading the cookie. Use {@link getFeatureFlagCookieName} method instead and manually extract the cookie contents from browser's cookie storage.
 *
 * @param {String} cookies - String with all cookies (ie: `document.cookie`)
 * @return {String} LaquesisFF cookie content
 */
function getLaquesisFFCookie(cookies) {
  if (cookies) {
    const regex = new RegExp(`${(0, _getFeatureFlagCookieName.default)()}=([^;]+)(;|$)`);
    const match = cookies.match(regex);
    if (match) return match[1].trim();
  }
  return '';
}
var _default = getLaquesisFFCookie;
exports.default = _default;